<template>
  <div class="mt-2">
    <form data-vv-scope="comment-management">
      <vs-textarea
        class="mb-0"
        maxlength="255"
        label="Comentario"
        v-model="comment"
        name="comment"
        v-validate="{required: true, min: 5}"
      />
      <div
        v-if="errors.first('comment-management.comment')"
        class="con-text-validation span-text-validation-danger
         vs-input--text-validation-span v-enter-to"
        style="height: 20px;">
        <span class="span-text-validation">
          {{errors.first('comment-management.comment')}}
        </span>
      </div>
    </form>
    <b-overlay :show="loading">
      <div class="row">
        <div class="col-12 text-right">
          <b-button
            class="mr-2 mt-3"
            data-cy="process-massive-button"
            variant="primary"
            size="sm"
            @click="sendAction"
          >
            Confirmar {{action}}
          </b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>

import { updateFileDD } from '@/febos/servicios/api/docDigital.api';

export default {
  name: 'ModalProcessDD',
  data() {
    return {
      error: {
        message: ''
      },
      comment: '',
      loading: false
    };
  },
  computed: {
    action() {
      let buttonText = '';
      switch (this.process) {
        case 'return':
          buttonText = 'Devolver';
          break;
        case 'read':
          buttonText = 'Acuse Recibo';
          break;
        default:
          buttonText = '';
          break;
      }
      return buttonText;
    }
  },
  methods: {
    cancelProcess() {
      this.comment = '';
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async sendAction() {
      const isValid = await this.validateForm('comment-management');
      if (!isValid) {
        return;
      }

      this.loading = true;
      if (this.process === 'return') {
        await updateFileDD(
          'put',
          `/api/documentos/recibidos/${this.file.id}/devolver`,
          {},
          {
            motivo: this.comment
          }
        );
        await this.$vs.notify({
          title: 'Genial!',
          text: 'Se ha avisado a DocDigital de este documento',
          color: 'success',
          time: 5000,
          position: 'top-center'
        });
        this.comment = '';
        this.loading = false;
        await this.$emit('close-modal');
      } else {
        await updateFileDD(
          'put',
          `/api/documentos/recibidos/${this.file.id}/acusorecibo`,
          {},
          {
            motivo: this.comment
          }
        );
        this.$vs.notify({
          title: 'Genial!',
          text: 'Se ha avisado a DocDigital de este documento',
          color: 'success',
          time: 5000,
          position: 'top-center'
        });
      }
      this.comment = '';
      this.loading = false;
      await this.$emit('close-modal');
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.sendAction();
    },
    mounted() {
      this.comment = '';
    }
  },
  props: {
    process: { type: String, required: true },
    file: { type: Object, required: true },
  }
};
</script>
